import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';

export function useE09AcceptFile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (fileId: number) => {
      try {
        const response = await axios.get(`/data-set/e09/accept`, {
          params: {
            dataSet: fileId
          }
        });
        return response.data;
      } catch (error) {
        // Extract backend error message and throw as Error for caller to handle
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          let errorMessage = 'Failed to accept file';

          if (axiosError.response?.data) {
            const data = axiosError.response.data as any;
            if (typeof data === 'string') {
              errorMessage = data;
            } else if (data.message) {
              errorMessage = data.message; // e.g. "File in status D cannot be accepted"
            } else if (data.error) {
              errorMessage = data.error;
            } else if (data.detail) {
              errorMessage = data.detail;
            } else if (data.errorMessage) {
              errorMessage = data.errorMessage;
            }
          } else if (axiosError.message) {
            errorMessage = axiosError.message;
          }

          throw new Error(errorMessage);
        }

        throw error as Error;
      }
    },
    onSuccess: () => {
      // Invalidate relevant queries to trigger refetch
      queryClient.invalidateQueries({ queryKey: ['e09Samples'] });
      queryClient.invalidateQueries({ queryKey: ['e09FileDetails'] });
    }
  });
} 